import styled from 'styled-components'

export const FlyoutHeaderWrap = styled.div `
    background-color: #ffffff;
    padding: 15px 0;
`;